import { Button, Link } from "@heroui/react"
import classes from "./Sidebar.module.scss"
import Logo from "../Logo"
import { useAuth } from "../../context/AuthContext"
import { clsx } from "clsx"

const links = [
  {
    label: "מערכת",
  },
  {
    label: "דשבורד",
    href: "/",
  },
  {
    label: "מורים",
    href: "/teachers",
  },
  {
    label: "תלמידים",
    href: "/students",
  },
  {
    label: "לידים",
    href: "/leads",
  },
  {
    label: "מרכז העזרה",
  },
  {
    label: "מאמרים",
    href: "/articles",
  },
  {
    label: "קטגוריות",
    href: "/categories",
  },
]

const Sidebar = () => {
  const {
    auth: {
      isLoggedIn,
      admin: { firstName },
      user,
    },
    logout,
  } = useAuth()

  if (!isLoggedIn) {
    return null
  }

  return (
    <div
      className={clsx(
        "relative w-[250px] h-[100vh] overflow-hidden",
        classes.root,
      )}
    >
      <div className="fixed right-0 w-[250px] h-[100vh] px-7 py-4 bg-[#0E0E0E] flex flex-col gap-7">
        <div className="flex gap-3">
          <Link href="/">
            <Logo height={35} width={17} />
          </Link>
          <div className="flex flex-col">
            <p className="text-md">היי {firstName}</p>
            <p className="text-small text-default-500">{user.email}</p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {links.map((link) => {
            if (link.href) {
              const isActive =
                window.location.pathname.trim() === link.href.trim()

              return (
                <Link
                  color={isActive ? "primary" : "foreground"}
                  href={link.href}
                  className={clsx({ [classes.inactive]: !isActive })}
                >
                  {link.label}
                </Link>
              )
            }
            return <span className={classes.sectionTitle}>{link.label}</span>
          })}
        </div>
        <Button
          color="danger"
          className="mt-auto"
          variant="flat"
          onClick={logout}
        >
          התנתק
        </Button>
      </div>
    </div>
  )
}

export default Sidebar
